import { render, staticRenderFns } from "./WaitingForRoadmap.vue?vue&type=template&id=5abdf218"
import script from "./WaitingForRoadmap.vue?vue&type=script&lang=js"
export * from "./WaitingForRoadmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports